// API client for user posts and their comments (/user-posts).

const baseAPI_URL = process.env.REACT_APP_BACKEND_API_BASE_ENDPOINT;

async function request(path, { token, method = "GET", body } = {}) {
  const response = await fetch(`${baseAPI_URL}/user-posts${path}`, {
    method,
    headers: {
      ...(body ? { "Content-Type": "application/json" } : {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: body ? JSON.stringify(body) : undefined,
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    const error = new Error(data?.error || "Não foi possível completar a requisição.");
    error.status = response.status;
    throw error;
  }

  return data;
}

export async function getPostsByAuthor(token, authorId) {
  const data = await request(`/get-by-author/${authorId}`, { token });
  return data.posts || [];
}

export async function getMyPosts(token) {
  const data = await request("/get-mine", { token });
  return data.posts || [];
}

// Returns a page of posts from all users (feed), newest first.
// Response: { posts, offset, limit, total, has_next, has_prev }
export async function getAllPosts(token, { offset = 0, limit = 20 } = {}) {
  const params = new URLSearchParams({
    offset: String(offset),
    limit: String(limit),
  });
  return request(`/get-all?${params}`, { token });
}

export async function getPostById(token, postId) {
  return request(`/get/${postId}`, { token });
}

export async function createPost(token, { title, description, images }) {
  return request("/create", {
    token,
    method: "POST",
    body: { title, description, images },
  });
}

export async function updatePost(token, postId, { title, description, images } = {}) {
  const body = {};
  if (title !== undefined) body.title = title;
  if (description !== undefined) body.description = description;
  if (images !== undefined) body.images = images;
  return request(`/update/${postId}`, {
    token,
    method: "PUT",
    body,
  });
}

export async function deletePost(token, postId) {
  return request(`/delete/${postId}`, { token, method: "DELETE" });
}

export async function getComments(token, postId) {
  const data = await request(`/${postId}/comments`, { token });
  return data.comments || [];
}

export async function createComment(token, postId, content) {
  return request(`/${postId}/comments/create`, {
    token,
    method: "POST",
    body: { content },
  });
}

export async function updateComment(token, postId, commentId, content) {
  return request(`/${postId}/comments/update/${commentId}`, {
    token,
    method: "PUT",
    body: { content },
  });
}

export async function deleteComment(token, postId, commentId) {
  return request(`/${postId}/comments/delete/${commentId}`, {
    token,
    method: "DELETE",
  });
}

// Requests presigned S3 upload URLs for the given files.
// `files` is an array of { file_type, file_extension? }.
export async function getPresignedUploadUrls(token, files) {
  const data = await request("/gen-presigned-upload-urls", {
    token,
    method: "POST",
    body: { files },
  });
  return data.targets || [];
}

// Uploads a single file to its presigned S3 URL.
export async function uploadImageToS3(uploadUrl, file) {
  const response = await fetch(uploadUrl, {
    method: "PUT",
    headers: { "Content-Type": file.type },
    body: file,
  });
  if (!response.ok) {
    throw new Error("Erro ao enviar imagem.");
  }
}
